import { FieldValue } from 'firebase/firestore';
import { useCallback, useEffect, useState } from 'react';
import { LegalEntity, Order, PrroReceipt } from '../../../apiTypes';
import { useAdmin } from '../../../contexts/admin.context';
import { updateDoc } from '../../../utils/api';

type Props = {
  orderId: string;
  receipt: PrroReceipt;
  legalEntity: DbDocument<LegalEntity> | undefined;
  setError: (error: string) => void;
};

const usePrroReceiptStatus = ({ receipt, legalEntity, orderId, setError }: Props) => {
  const { cafeSlug } = useAdmin();
  const { cashierToken } = legalEntity?.prroCheckBox || {};
  const [count, setCount] = useState(0);

  const checkReceipt = useCallback(async () => {
    if (cashierToken && receipt.status !== 'complete' && receipt.id && legalEntity?.id) {
      const res = await fetch(`https://api.checkbox.in.ua/api/v1/receipts/${receipt.id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cashierToken}`,
          'X-Client-Name': 'FireMenu',
          'X-Client-Version': 'v0.1.1',
        },
      });

      const resJson = await res.json();

      if (resJson.message) {
        setError(resJson.message);
        return;
      }

      if (resJson.status === 'DONE') {
        setError('');

        await updateDoc<Order>(`cafes/${cafeSlug}/orders/${orderId}`, {
          [`prroReceipts.${legalEntity.id}.status`]: 'complete' as unknown as FieldValue,
        });

        return;
      }

      if (count < 10) {
        setTimeout(() => {
          setCount(count + 1);
        }, 3000);
      }
    }
  }, [cafeSlug, cashierToken, count, legalEntity?.id, orderId, receipt.id, receipt.status, setError]);

  useEffect(() => {
    if (receipt.id) {
      checkReceipt();
    }
  }, [checkReceipt, receipt.id]);

  return null;
};

export default usePrroReceiptStatus;
